import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.freeze.js";
import "core-js/modules/es.object.define-properties.js";

var _templateObject,
    _effectorFileName = "/builds/gmini/front-common/src/components/FilterPanel/components/FilterButton/FilterButton.styled.ts",
    _templateObject2;

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

import { IconButton } from '@gmini/ui-kit';
import styled, { css } from 'styled-components';
export var GlobalFilterButton = styled(IconButton)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", "\n"])), function (props) {
  return props.applied && css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n      && {\n        background: #4c5ecf;\n\n        path {\n          fill: #fff;\n        }\n      }\n\n      &&:hover {\n        background: #2235aa;\n      }\n    "])));
});